import {
  FETCH_ORGANIZATIONS_RESOLVED,
  FETCH_ORGANIZATIONS_REQUEST,
  FETCH_ORGANIZATIONS_REJECTED,
  FETCH_ORGANIZATION_RESOLVED,
  FETCH_ORGANIZATION_ADMINS_RESOLVED,
  EDIT_ADMIN,
  CREATE_ADMIN,
  EDIT_ORGANIZATIONS_REQUEST,
  CREATE_ORGANIZATIONS_REQUEST,
} from "../ActionTypes/organizations";

const initialState = {
  organizationList: [],
  organization: {},
  admins: [],
  loading: false,
  error: null,
  pagination: {}
};

export default function organizationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ORGANIZATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_ORGANIZATIONS_RESOLVED:
      return {
        ...state,
        loading: false,
        organizationList: action.payload,
        pagination: action.meta?.pagination || {},
        error: null
      };

    case FETCH_ORGANIZATIONS_REJECTED:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case FETCH_ORGANIZATION_RESOLVED: {
      return {
        ...state,
        organization: action.payload
      };
    }

    case FETCH_ORGANIZATION_ADMINS_RESOLVED: {
      return {
        ...state,
        admins: action.payload,
      };
    }

    case CREATE_ADMIN: {
      let admins = JSON.parse(JSON.stringify(state.admins));
      admins.push(action.payload);
      return Object.assign({}, state, {
        admins
      });
    }

    case EDIT_ADMIN:{
      let admins = JSON.parse(JSON.stringify(state.admins));
      admins.forEach((item, index) => {
        if (item.id == action.payload.id) {
          admins[index] = action.payload;
        }
      });
      return Object.assign({}, state, {
        admins
      });
    }

    case CREATE_ORGANIZATIONS_REQUEST: {
      let organizationList = JSON.parse(JSON.stringify(state.organizationList));
      organizationList.push(action.payload);
      return Object.assign({}, state, {
        organizationList
      });
    }

    case EDIT_ORGANIZATIONS_REQUEST: {
      let organizationList = JSON.parse(JSON.stringify(state.organizationList));

      if(organizationList.length == 0) {
        return Object.assign({}, state, {
          organization : action.payload,
        });
      }

      organizationList.forEach((item, index) => {
        if (item.id == action.payload.id) {
          organizationList[index] = action.payload;
        }
      });
      return Object.assign({}, state, {
        organizationList
      });
    }
    default:
      return state;
  }
}
